import { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  actionLabel?: string;
  /** Navigate to a URL. Mutually exclusive with onAction. */
  actionUrl?: string;
  /** Trigger a modal or callback. Used when there's no URL to navigate to. */
  onAction?: () => void;
  /** Placeholder secondary link text (e.g. "Learn more") */
  secondaryLabel?: string;
  secondaryUrl?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  actionUrl,
  onAction,
  secondaryLabel,
  secondaryUrl,
}: EmptyStateProps) {
  return (
    <div
      role="status"
      className="flex flex-col items-center justify-center py-12 text-center"
    >
      <Icon className="h-10 w-10 text-muted-foreground/40 mb-3" />
      <h3 className="text-base font-medium text-foreground mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground mb-4 max-w-xs">{description}</p>
      )}
      {actionLabel && (actionUrl || onAction) && (
        <div className="flex flex-col items-center gap-2">
          {actionUrl ? (
            <Button asChild>
              <Link to={actionUrl}>{actionLabel}</Link>
            </Button>
          ) : (
            <Button onClick={onAction}>{actionLabel}</Button>
          )}
          {secondaryLabel && secondaryUrl && (
            <a
              href={secondaryUrl}
              className="text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground"
            >
              {secondaryLabel}
            </a>
          )}
        </div>
      )}
    </div>
  );
}
